import gql from 'graphql-tag';

const GET_STUDENT_STATS = gql`
  query getStudentStats($id: Int!) {
    student(where: { id: $id }) {
      id
      firstName
      lastName
      organization {
        id
        name
        type
        rootOrganization {
          id
          name
          type
        }
      }
      classrooms {
        id
        name
        dateArchived
        organizationId
      }
    }
  }
`;

export default GET_STUDENT_STATS;
